export const ja = {
    common: {
        cancel: 'キャンセル',
        save: '保存',
        delete: '削除',
        edit: '編集',
        create: '作成',
        loading: '読み込み中…',
        copy: 'コピー',
        ok: 'OK',
        close: '閉じる',
        or: 'または',
        creating: '作成中...',
        unknownError: '不明なエラー',
        none: 'なし',
        color: 'カラー',
        visible: '表示',
        locked: 'ロック',
        hide: '非表示',
        show: '表示',
        lock: 'ロック',
        unlock: 'ロック解除',
        update: '更新',
    },
    language: {
        label: '言語',
    },
    auth: {
        welcome: 'tween.studioへようこそ — モーションをデザインし、シーンを作り、物語に命を吹き込みましょう。',
        email: 'メール',
        password: 'パスワード',
        emailPlaceholder: 'you@example.com',
        name: '名',
        surname: '姓',
        namePlaceholder: 'Ada',
        surnamePlaceholder: 'Lovelace',
        confirmPassword: 'パスワード確認',
        termsOfService: '利用規約',
        privacyPolicy: 'プライバシーポリシー',
        and: 'および',
        signInTitle: 'ログイン',
        signInSubtitle: '前回の続きから始めましょう。',
        signIn: 'ログイン',
        signingIn: 'ログイン中...',
        noAccount: 'アカウントをお持ちでないですか？',
        signUp: '登録',
        loginFailed: 'ログインに失敗しました',
        googleSignInFailed: 'Googleログインに失敗しました',
        googleSignInLoadFailed: 'Googleログインを読み込めませんでした',
        continueWithFacebook: 'Facebookで続行',
        continueWithInstagram: 'Instagramで続行',
        metaSignInComingSoon: '{brand}ログインはMeta Loginを使用します — 接続は近日対応。プロバイダーは管理画面で設定できます。',
        createAccountTitle: 'アカウント作成',
        createAccountSubtitle: 'tween.studioに参加してアニメーションを始めましょう。',
        createAccount: 'アカウント作成',
        creatingAccount: 'アカウント作成中...',
        hasAccount: 'すでにアカウントをお持ちですか？',
        signInLink: 'ログイン',
        termsAgreePrefix: 'アカウントを作成すると、',
        termsAgreeSuffix: 'に同意したことになります。',
        passwordMinLength: 'パスワードは6文字以上である必要があります。',
        passwordsDoNotMatch: 'パスワードが一致しません。',
        registrationFailed: '登録に失敗しました',
    },
    theme: {
        label: 'テーマ',
        light: 'ライト',
        dark: 'ダーク',
        system: 'システム',
        switchToLight: 'ライトモードに切り替え',
        switchToDark: 'ダークモードに切り替え',
    },
    connection: {
        Connected: '接続済み',
        Connecting: '接続中',
        Reconnecting: '再接続中',
        Disconnected: '切断',
        Error: 'エラー',
    },
    toolbar: {
        selectMovie: 'ムービーを選択',
        ai: 'AI',
        notifications: '通知',
        loadingNotifications: '通知を読み込み中...',
        noNotifications: '通知はまだありません。',
        zoom: 'ズーム',
        zoomLevel: 'ズームレベル',
        zoomIn: '拡大',
        zoomOut: '縮小',
        zoomPercent: 'ズーム {percent}%',
        shapes: '図形',
        objects3d: '3Dオブジェクト',
        characters: 'キャラクター',
        characterPresets: {
            humanoid: '人型',
            animal: '動物',
            turtle: 'カメ',
            octopus: 'タコ',
        },
        sceneEffects: 'シーンエフェクト',
        sceneEffectsLabel: 'シーンエフェクト',
        activeEffects: '有効なエフェクト {count} 件',
        clearAllEffects: 'すべてのエフェクトをクリア',
        tools: {
            select: '選択 (V)',
            pan: '手のひら (H、Space長押し)',
            line: '直線 (L)',
            curve: '曲線 (P)',
            text: 'テキスト (T)',
            rectangle: '矩形 (R)',
            circle: '円 (C)',
            triangle: '三角形',
            polygon: '多角形 (G)',
            cube3d: '3Dキューブ',
            sphere3d: '3D球体',
            box3d: '3Dボックス',
            cylinder3d: '3D円柱',
            prism3d: '3Dプリズム',
            mesh3d: '3Dメッシュ',
            fog: '霧',
            rain: '雨',
            snow: '雪',
            lightning: '雷',
            particles: 'パーティクル',
            vignette: 'ビネット',
        },
    },
    movieSelector: {
        newMovie: '新しいムービー',
        createNewMovie: '新しいムービーを作成',
        movieNamePlaceholder: 'ムービー名...',
        movieDescriptionPlaceholder: 'ムービーの説明...',
        recent: '最近',
        myProjects: 'マイプロジェクト',
        sampleMovies: 'サンプルムービー',
        currentMovie: '現在のムービー',
        unloadMovie: 'ムービーを閉じる',
        closeMovie: 'ムービーを閉じる',
        deleteMovie: 'ムービーを削除',
        moreActions: 'その他の操作',
        selectToPreview: 'プレビューするムービーを選択',
        deleteConfirmTitle: 'ムービーを削除しますか？',
        deleteConfirmDescription: '「{name}」は完全に削除されます。',
        thisMovie: 'このムービー',
        movieAria: 'ムービー',
        today: '今日',
        yesterday: '昨日',
        daysAgo: '{count}日前',
        older: 'それ以前',
        errors: {
            idUnresolved: 'ムービーIDを解決できませんでした。',
            nameEmpty: 'ムービー名を空にすることはできません。',
            saveFailed: 'ムービーの保存に失敗しました。もう一度お試しください。',
        },
    },
    userMenu: {
        ariaLabel: 'ユーザーメニュー',
        sectionsAria: 'ユーザーメニューのセクション',
        tabs: {
            credits: 'クレジット',
            account: 'アカウント',
            preferences: '設定',
        },
        administration: '管理',
        signOut: 'サインアウト',
        loadingCredits: 'クレジットを読み込み中',
        creditsCount: '{count} クレジット',
        credits: {
            currentBalance: '現在の残高',
            unit: 'クレジット',
            add: 'クレジットを追加',
            hideAdd: 'クレジット追加を隠す',
            hideAddOptions: 'クレジット追加オプションを隠す',
            loadingPurchase: '購入オプションを読み込み中...',
            noCardOptions: 'カード決済オプションが設定されていません。',
            planCredits: '{count} クレジット',
            loadWithTether: 'Tether (USDT) でチャージ',
            loadingDeposit: '読み込み中...',
            noUsdtWallet: 'USDTウォレットアドレスが設定されていません。',
            rate: '1 {symbol} = {credits} クレジット',
            copyAddress: 'アドレスをコピー',
            recentTransactions: '最近の取引',
            loadingTransactions: '取引を読み込み中...',
            noTransactions: 'まだ取引がありません。',
        },
        account: {
            creditUsage: 'クレジット使用状況',
            balance: '残高',
            earned: '獲得',
            spent: '使用',
            transactions: '取引',
            changePassword: 'パスワードを変更',
            changePasswordTitle: 'パスワード変更',
            currentPassword: '現在のパスワード',
            currentPasswordHint: 'ソーシャルのみのアカウントでは空のままにしてください',
            newPassword: '新しいパスワード',
            confirmPassword: '新しいパスワードの確認',
            updatePassword: 'パスワードを更新',
            saving: '保存中…',
            errors: {
                newRequired: '新しいパスワードが必要です。',
                minLength: '新しいパスワードは6文字以上である必要があります。',
                mismatch: '新しいパスワードと確認が一致しません。',
                failed: 'パスワードの変更に失敗しました。',
            },
            success: 'パスワードが正常に変更されました。',
        },
    },
    sidebar: {
        collapse: 'パネルを折りたたむ',
        expand: 'パネルを展開',
    },
    toolpads: {
        library: {
            title: 'ライブラリ',
            dropImages: '画像をここにドロップ',
            importFiles: 'ファイルをインポート',
            import: '+ インポート',
            importAria: 'ファイルをインポート',
            uploading: 'アップロード中…',
            deleteConfirmTitle: 'ライブラリ項目を削除しますか？',
            deleteConfirmDescription: '「{name}」は完全に削除されます。',
            deleteFailedTitle: '削除できませんでした',
            deleteFailedFallback: '削除できませんでした。',
            inUseTitle: 'ライブラリ項目が使用中です',
            inUseDescription: '「{name}」は少なくとも1つのシーンオブジェクトで使用されています（{count}件）。先にシーンから削除してください。',
            noLayerTitle: 'レイヤーが選択されていません',
            noLayerDescription: 'シーンオブジェクトを追加する前にレイヤーを選択してください。',
            mine: 'プロジェクト',
            vectorHint: 'ステージへドラッグするかダブルクリックして、このプロジェクトにコピーします。',
            vectorsEmpty: '公開ライブラリは空です。',
            vectorsLoadFailed: '公開ライブラリを読み込めませんでした。',
            vectorUseFailed: 'ライブラリ項目をプロジェクトに追加できませんでした。',
        },
        scenes: {
            title: 'シーン',
            empty: 'まだシーンがありません。',
            add: '+ シーンを追加',
            defaultName: 'シーン {count}',
            nameAria: 'シーン名',
            dragReorder: 'ドラッグして並べ替え',
            deleteTitle: 'シーンを削除',
            deleteDescription: '「{name}」は削除されます。',
            deleteTooltip: 'シーンを削除',
            cannotDeleteTitle: 'シーンを削除できません',
            cannotDeleteLast: 'ムービーには少なくとも1つのシーンが必要です。最後のシーンは削除できません。',
            createFailed: 'シーンを作成できませんでした: {error}',
            deleteFailed: 'シーンを削除できませんでした: {error}',
        },
        sceneObjects: {
            title: 'シーンオブジェクト',
            empty: 'ライブラリからドラッグしてシーンにオブジェクトを追加します。',
            selectAll: 'すべて選択',
            selectAllAria: 'すべてのシーンオブジェクトを選択',
            selectedCount: '{count} 件選択中',
            expand: '展開',
            collapse: '折りたたむ',
            objectNameAria: 'オブジェクト名',
            selectObject: '{name} を選択',
            selectObjectAndChildren: '{name} とその子を選択',
            deselectObjectAndChildren: '{name} とその子の選択を解除',
            selectAllChildren: 'すべての子を選択',
            all: 'すべて',
        },
        sceneEffects: {
            title: 'シーンエフェクト',
            empty: 'ツールバーからシーンエフェクトを有効にすると、ここでパラメータを調整できます。',
            activeCount: '{count} 件有効',
            clearAll: 'すべてクリア',
            expand: 'パラメータを展開',
            collapse: 'パラメータを折りたたむ',
            enable: 'エフェクトを有効化',
            disable: 'エフェクトを無効化',
            params: {
                intensity: '強度',
                speed: '速度',
                particleSize: 'パーティクルサイズ',
                color: '色',
            },
        },
        clipFolders: {
            title: 'クリップフォルダ',
            empty: 'クリップフォルダがありません。',
            add: '+ フォルダを追加',
            defaultName: 'フォルダ {count}',
            deleteTooltip: 'フォルダを削除',
        },
        movieProperties: {
            title: 'ムービープロパティ',
            stageSize: 'ステージサイズ',
            width: '幅',
            height: '高',
            frameRate: 'フレームレート',
            frameRateAria: 'フレームレート',
            fpsOption: '{count} FPS',
            info: '情報',
            name: '名前: ',
            scenes: 'シーン: ',
            noMovie: 'ムービーが読み込まれていません。',
            publish: '公開',
            publishing: '公開中…',
            publishHint: '公開プレイヤー用の読み取り専用スナップショットを作成します。',
            linkCopied: 'プレイヤーリンクをコピーしました。',
        },
    },
    rightSidebar: {
        style: {
            title: 'スタイル',
            selectObject: '色を調整するにはステージ上のオブジェクトを選択してください。',
            shapeOrTextOnly: 'スタイル設定は図形・テキスト・画像オブジェクトに適用されます。',
            text: 'テキスト',
            textColor: 'テキストの色',
            fontSize: 'フォントサイズ',
            fontSizeAria: 'フォントサイズ',
            fontSizePxAria: 'フォントサイズ px',
            align: '整列',
            textAlignAria: 'テキスト整列',
            left: '左',
            center: '中央',
            right: '右',
            justify: '両端揃え',
            colors: 'カラー',
            fill: '塗り',
            fillModeAria: '塗りモード',
            fillSolid: 'カラー',
            fillGradient: 'グラデーション',
            fillColor: '塗り色',
            gradientStart: '開始',
            gradientEnd: '終了',
            gradientAngle: '角度',
            gradientAngleAria: 'グラデーション角度',
            border: '境界線',
            borderTypeAria: '境界線の種類',
            borderColor: '境界線の色',
            borderSizeAria: '境界線のサイズ',
            size: 'サイズ',
            sides: '辺',
            sidesAria: '境界線の辺',
            sideTop: '上',
            sideRight: '右',
            sideBottom: '下',
            sideLeft: '左',
            solid: '実線',
            dashed: '破線',
            dotted: '点線',
            fillBorderConflict: '塗りと境界線を同時になしにはできません。',
            effects: 'エフェクト',
            shadow: '影',
            shadowColor: '影の色',
            shadowOffsetX: 'オフセット X',
            shadowOffsetY: 'オフセット Y',
            shadowBlur: 'ぼかし',
            shadowSpread: '広がり',
            glow: 'グロー',
            glowColor: 'グローの色',
            glowBlur: 'グローぼかし',
            enabled: 'オン',
            disabled: 'オフ',
        },
        properties: {
            title: 'プロパティ',
            object: 'オブジェクト',
            tween: 'トゥイーン',
            transform: '変形',
            stageTools: 'ステージツール',
            stageResize: 'Resize',
            stageRotate: 'Rotate',
            stageResizeHint: '選択オブジェクトにリサイズハンドルを表示',
            stageRotateHint: '選択オブジェクトに角の回転ハンドルとピボットを表示',
            pivotHint: 'ドラッグして回転ピボット／ジョイントを設定',
            keepAspectRatio: '縦横比を維持',
            keepAspectRatioHint: 'Shift を押しながらのリサイズ時にも一時的に有効になります。',
            appearance: '外観',
            rotation: '回転',
            rotationAria: '回転',
            rotationDegreesAria: '回転角度',
            opacity: '不透明度',
            opacityAria: '不透明度',
            opacityPercentAria: '不透明度パーセント',
            visibility: '表示',
            activeTween: 'アクティブなトゥイーン ({start} → {end})',
            easing: 'イージング',
            easingAria: 'イージングの種類',
            linear: 'Linear',
            easeIn: 'Ease In',
            easeOut: 'Ease Out',
            easeInOut: 'Ease In-Out',
            bounce: 'Bounce',
            elastic: 'Elastic',
            back: 'Back',
            noTween: '現在のフレームにトゥイーンがありません。',
            noTweenHint: '2つのキーフレームを作成し、その間にトゥイーンを追加してください。',
            allTweens: 'すべてのトゥイーン',
            frameRange: 'フレーム {start} → {end}',
            noSelection: 'プロパティを表示・編集するにはシーンまたはタイムラインで何かを選択してください。',
            selectedObjects: '{count} 個のオブジェクトを選択中',
            selectedObjectAria: '選択内で編集するオブジェクト',
            keyframe: 'キーフレーム',
            frame: 'フレーム:',
            activeKeyframe: '◆ アクティブなキーフレーム: フレーム {frame}',
            noKeyframe: '現在のフレーム以前にキーフレームがありません',
            selectFrameHint: 'タイムラインからフレームを選択',
            createKeyframe: 'キーフレームを作成',
            updateKeyframe: 'キーフレームを更新',
            stateObjects: '状態を持つオブジェクト',
            noStateObjects: 'このキーフレームにオブジェクトの状態はありません。',
            copyStateToPrevious: '前のキーフレームへ状態をコピー ({frame})',
            copyStateToNext: '次のキーフレームへ状態をコピー ({frame})',
            noPreviousKeyframe: '前のキーフレームがありません',
            noNextKeyframe: '次のキーフレームがありません',
        },
        align: {
            title: '整列',
            horizontal: '水平',
            vertical: '垂直',
            left: '左揃え',
            center: '中央揃え',
            right: '右揃え',
            top: '上揃え',
            middle: '上下中央',
            bottom: '下揃え',
        },
    },
    timeline: {
        prevFrame: '前のフレーム (,)',
        pause: '一時停止 (Space)',
        play: '再生 (Space)',
        playNeedsKeyframe: '再生には少なくとも1つのキーフレームが必要です',
        stop: '停止 (.)',
        nextFrame: '次のフレーム (.)',
        addKeyframe: 'キーフレームを追加 (F6)',
        deselectKeyframe: 'プレイヘッドに追加するにはキーフレームの選択を解除',
        keyframeExists: '現在のフレームに既にキーフレームがあります',
        deleteKeyframe: 'キーフレームを削除',
        addTween: 'トゥイーンを追加 (F7)',
        addTweenHint: 'トゥイーンがない場合、2つのキーフレームの間に追加できます',
        deleteTween: 'トゥイーンを削除',
        frame: 'フレーム:',
        time: '時間:',
        total: '合計:',
        totalFramesAria: '合計フレーム',
        addLayer: 'レイヤーを追加',
        newLayer: '新しいレイヤー',
        dragReorder: 'ドラッグして並べ替え',
        deleteLayer: 'レイヤーを削除',
        cannotDeleteTitle: 'レイヤーを削除できません',
        cannotDeleteLast: 'シーンには少なくとも1つのレイヤーが必要です。最後のレイヤーは削除できません。',
        cannotDeleteNonEmpty: 'このレイヤーは空ではありません。削除する前にキーフレーム、トゥイーン、シーンオブジェクトをクリアしてください。',
        tweenTitle: 'トゥイーン: {start} - {end} ({easing})',
        frameTitle: 'フレーム {frame}',
        frameDeleting: 'フレーム {frame} (削除中...)',
        addKeyframeAt: 'キーフレームを追加 (フレーム {frame})',
        addTweenShort: 'トゥイーンを追加',
        clearAllKeyframes: 'すべてのキーフレームをクリア',
        clearAllTweens: 'すべてのトゥイーンをクリア',
    },
    stage: {
        selectionToolbar: 'オブジェクト操作',
        duplicate: '複製',
        createGroup: 'グループ作成',
        createPattern: 'パターンを作成',
        ungroup: 'グループ解除',
        removeFromGroup: 'グループから外す',
        groupName: 'グループ',
        insideThisLayer: 'このレイヤー内',
        bringToFront: '最前面へ',
        bringForward: '前面へ',
        sendBackward: '背面へ',
        sendToBack: '最背面へ',
        sendToLayer: 'レイヤーへ送る',
        sendInto: '中に送る',
        noSendIntoTargets: 'このレイヤーに他のオブジェクトがありません',
        objectFallback: 'オブジェクト {id}',
        noLayers: 'レイヤーなし',
        layerFallback: 'レイヤー {id}',
        noLayerTitle: 'レイヤーが選択されていません',
        noLayerDescription: 'シーンオブジェクトを追加するには、先にレイヤーを選択してください。',
    },
    welcome: {
        title: 'ようこそ',
        subtitle: '新しいプロジェクトを作成するか、最近使ったプロジェクトを選択できます。',
        createProject: '新しいプロジェクトを作成',
        projectNamePlaceholder: 'プロジェクト名...',
        recentlyUsed: '最近使用したもの',
        noRecent: '最近使用したプロジェクトはありません',
        myProjects: 'マイプロジェクト',
        sampleProjects: 'サンプルプロジェクト',
        empty: 'まだプロジェクトがありません。新しいプロジェクトを作成して始めましょう！',
        movieAria: 'ムービー',
        previewTitle: 'プレビュー',
        openProject: 'プロジェクトを開く',
        noDescription: '説明なし',
        resolution: '解像度',
        fps: 'フレームレート',
        fpsValue: '{fps} fps',
        scenes: 'シーン',
        sceneObjects: 'シーンオブジェクト',
        layers: 'レイヤー',
        sampleBadge: 'サンプル',
    },
    aiChat: {
        deleteMessage: 'メッセージを削除',
        thinking: '考え中...',
        jobs: 'ジョブ',
        actions: 'アクション',
        payloads: 'ペイロード',
        executionResults: '実行結果',
        loading: '読み込み中...',
        resizePanel: 'チャットパネルのサイズ変更',
        selectConversation: '会話を選択',
        newChat: '新しいチャット',
        newChatTooltip: '新しいチャット',
        deleteConversation: '会話を削除',
        debugOn: 'デバッグモードオン',
        debugOff: 'デバッグモードオフ',
        placeholder: 'シーンを説明してください ...',
        send: '送信',
    },
    admin: {
        badge: 'Admin',
        backToEditor: 'エディターに戻る',
        topbarTitle: 'Admin',
        a11y: {
            closeNav: 'ナビゲーションを閉じる',
            openNav: 'ナビゲーションを開く',
        },
        nav: {
            dashboard: 'ダッシュボード',
            users: 'ユーザー',
            projects: 'プロジェクト',
            activity: 'アクティビティ',
            activityDesc: 'SignalR · ログ',
            activityTitle: 'ライブ SignalR 接続とアクティビティログ',
            storageProviders: 'ストレージプロバイダー',
            socialProviders: 'ソーシャルログイン',
            ai: 'AI',
            providers: 'プロバイダー',
            prompts: 'プロンプト',
            payment: '決済',
            cryptoWallets: '暗号ウォレット',
            disclaimers: '免責事項',
            install: 'インストール',
            analytics: '分析',
            settings: '設定',
            vectorPackages: '公開ライブラリ',
        },
        vectorPackages: {
            title: '公開ライブラリ',
            description: 'すべてのプロジェクトで共有するプラットフォームのライブラリです。Gitリポジトリを取り込むか、Zipをアップロードします。フォルダごとにパッケージになります。',
            name: 'パッケージ名',
            file: 'パッケージファイル',
            fileHint: 'Zip、SVG、PNG、WebP、JPEG。Zipは個別のファイルに展開されます。',
            upload: 'パッケージをアップロード',
            uploading: 'アップロード中…',
            empty: '公開ライブラリは空です。',
            files: '{count} ファイル',
            delete: '削除',
            preview: 'ファイル',
            hide: '隠す',
            deleteConfirm: '「{name}」とそのファイルを削除しますか？',
            uploadFailed: 'アップロードに失敗しました。',
            deleteFailed: 'パッケージを削除できませんでした。',
            nameRequired: 'パッケージ名は必須です。',
            fileRequired: 'パッケージファイルを選択してください。',
            loadFailed: '公開ライブラリを読み込めませんでした。',
            gitUrl: 'リポジトリURL',
            gitBranch: 'ブランチ',
            gitPath: 'フォルダ',
            gitFormat: '形式',
            formatSvg: 'SVG',
            formatPng: 'PNG',
            gitHint: 'HTTPSのみ。kitsのようなフォルダは、サブフォルダごとに1つのパッケージになります。SVGとPNGは同時に取り込みません。同じリポジトリを再度取り込むと、そのパッケージが更新されます。',
            gitImport: 'リポジトリを取り込む',
            gitImporting: '取り込み中…',
            gitImported: '{count} 件のパッケージを取り込みました。',
            gitFailed: 'リポジトリを取り込めませんでした。',
            gitUrlRequired: 'リポジトリURLは必須です。',
        },
    },
};
